import { render } from "./EvangelismType.vue?vue&type=template&id=65d88f22"
import script from "./EvangelismType.vue?vue&type=script&lang=js"
export * from "./EvangelismType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__